import React, { useState, useEffect } from 'react';
import { Box, Flex, Center, Container, Stack, Select, VStack, useColorMode, Button, Spacer, Spinner, useToast } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import useHttp from '../../utils/http'
import { Step } from '../Steps/Step'
import { steps } from '../Steps/data'
import { useStep } from '../Steps/useStep'
import { useAuth } from '../../context/AuthContext';
import { useGlobalContext } from '../../context/GlobalContext';
import ProcessDataJHT from './ProcessDataJHT'




const Form = ({ userDetails, setOrderSelected, setSelectedOrderInformation, setLocationSelected, setIsFormCompleted, setOperation, setOrderDetails, setOrderDetailsCopy, setPrintedTags }) => {
    const { get } = useHttp();
    const { colorMode } = useColorMode();
    const navigate = useNavigate();
    const toast = useToast();
    const [, dispatch] = useGlobalContext();


    const [currentStep, { setStep }] = useStep({
        maxStep: steps.length,
        initialStep: 0,
    })
    //const [logicalDevice, setLogicalDevice] = useState([])
    //const [order, setOrder] = useState('')
    const { operations } = userDetails;
    const [logicalDevices, setLogicalDevices] = useState({ devices: [] });
    const [allOrders, setAllOrders] = useState([]);
    const [selectedOperation, setSelectedOperation] = useState('');
    const [selectedOperationDescription, setSelectedOperationDescription] = useState(false);
    const [selectedLogicalDevice, setSelectedLogicalDevice] = useState({});
    const [selectedOrder, setSelectedOrder] = useState('')
    const [isLoadingDevices, setIsLoadingDevices] = useState(false);
    const [isLoadingTags, setIsLoadingTags] = useState(false);
    const [isLoadingOrders, setIsLoadingOrders] = useState(false);
    const { logout } = useAuth();

    const background = colorMode === "light" ? "gray.50" : "gray.700";
    useEffect(() => {
        const getLogicalDevices = async () => {
            setIsLoadingDevices(true);
            try {
                const response = await get("/api/operations/logicalDevices");
                setLogicalDevices(response?.data);
            } catch (error) {
                console.error("No pudo traer logical devices en FORM:", error.message);
                toast({
                    title: "Error",
                    description: !error.response ? "Server not responding or network error getting logical devices" : error.message,
                    status: "error",
                    duration: 9000,
                    isClosable: true,
                });
                if (!error.response) {
                    logout();
                    navigate('/login');
                } else if (error.response.status === 401) {
                    logout();
                    navigate('/login');
                }
            } finally {
                setIsLoadingDevices(false);
            }
        };
        getLogicalDevices();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const getPrintedTags = async () => {
            setIsLoadingTags(true);
            try {
                const username = process.env.REACT_APP_USER;
                const password = process.env.REACT_APP_PASSWORD;
                const response = await get('/api/print?hasBeenUsed=false', { timeout: 80000 }, { username, password });
                setPrintedTags(response?.data);
            } catch (error) {
                console.error(error.message);
                toast({
                    title: "Error",
                    description: !error.response ? "Server not responding or network error getting Printed Tags" : error.message,
                    status: "error",
                    duration: 9000,
                    isClosable: true,
                });
                if (!error.response) {
                    console.log(error.message);
                } else if (error.response.status === 401) {
                    logout();
                    navigate('/login');
                }
            } finally {
                setIsLoadingTags(false);
            }
        };
        getPrintedTags();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    function sortOrdersByOrderID(ordersArray) {
        return ordersArray.sort((a, b) => {
            if (a.OrderID < b.OrderID) {
                return -1;
            }
            if (a.OrderID > b.OrderID) {
                return 1;
            }
            return 0;
        });
    }

    const getOrders = async (operation) => {
        try {
            setIsLoadingOrders(true);;
            const response = await get(`/api/orders?operation=${operation}`);
            if (Array.isArray(response?.data)) {
                const sortedOrders = sortOrdersByOrderID(response?.data);
                setAllOrders(sortedOrders);
            } else {
                setAllOrders([]);
                console.log("Orders data is not an array or is empty.");
            }
        } catch (error) {
            console.error(error.message);
            toast({
                title: "Error",
                description: !error.response ? "Server not responding or network error getting order detail" : error.message,
                status: "error",
                duration: 9000,
                isClosable: true,
            });
            setIsLoadingOrders(false);
            if (!error.response) {
                // Additional logic if needed
            } else if (error.response.status === 401) {
                logout();
                navigate('/login');
            }
        } finally {
            setIsLoadingOrders(false);
        }
    };

    const getUseDescriptionByName = (name) => {
        //console.log("entro a getUseDescriptionByName")
        const result = operations.find(op => op.name === name);
        //console.log("En funcion", result);
        return result ? result.useDescription : null;
    }

    const handleOperationChange = (event) => {
        //console.log("entro a cambiar operacion");
        const operation = event.target.value;
        setStep(1);
        setSelectedOperation(operation);
        setOperation(operation); //Para enviar la operacion al componente padre   
        getOrders(operation);
        const operationDescriptionSet = getUseDescriptionByName(operation)
        console.log("Operation Selected", operationDescriptionSet);
        setSelectedOperationDescription(operationDescriptionSet);
    };

    const handleLogicalDeviceChange = (event) => {
        //console.log("entro a cambiar LogicalDevice");
        setStep(3);
        const selectedDevice = JSON.parse(event.target.value);
        setLocationSelected(selectedDevice); // to set in the parent component
        setSelectedLogicalDevice(selectedDevice);
        //console.log("setteado en setSelectedLogicalDevice", JSON.parse(event.target.value).name);
    };

    const handleOrderChange = (event) => {
        setStep(2);
        setSelectedOrder(event.target.value);   //Esta es solo para manejo local
        setOrderSelected(event.target.value);   //Para enviar el orderID al componente padre
        const customerOrder = allOrders.find(order => order.OrderID === event.target.value);
        //console.log("Order:", allOrders);
        setSelectedOrderInformation(customerOrder);
    };

    const handleGetOrderDetail = async () => {

        try {
            setIsLoadingOrders(true);
            const response = await get(`/api/orders/detail/${selectedOrder}?operation=${selectedOperation}`);
            console.log("Respuesta en handleGetOrderDetail", response.data);
            if (response.data) {
                setIsFormCompleted(true);
                const processData = ProcessDataJHT(response.data);
                setOrderDetails([processData]);
                setOrderDetailsCopy([processData]);
                setIsLoadingOrders(false);
                dispatch({
                    type: 'UPDATE_CONFIG',
                    payload: { inOperation: true } //Pone en true la variable inOperation en el contexto global para evitar que salga de la operacion
                });
            } else {
                console.log("Order data is empty.");
                setIsLoadingOrders(false);
            }
        } catch (error) {
            console.error(error);
            toast({
                title: "Error",
                description: error.code === 'ECONNABORTED' ? "Server not responding or network error" : error.message,
                status: "error",
                duration: 9000,
                isClosable: true,
            });

            setIsLoadingOrders(false);
            if (error.response?.status === 401) {
                logout();
            }
        }

        //setIsFormCompleted(true);

    };

    const reset = () => {
        setStep(0);
        setSelectedOperation('');
        setSelectedOrder('');
        setSelectedLogicalDevice('');
    };

    return (

        <Flex>
            <VStack flex='1' p={4} spacing={4}>
                <Center flex='1' >
                    <Box bg="bg.surface">
                        <Container
                            py={{
                                base: '4',
                                md: '8',
                            }}
                        >
                            <Center>
                                <Stack spacing="0">
                                    {steps.map((step, id) => (
                                        <Step
                                            key={id}
                                            cursor="pointer"
                                            //onClick={() => setStep(id)}
                                            title={step.title}
                                            description={step.description}
                                            isActive={currentStep === id}
                                            isCompleted={currentStep > id}
                                            isLastStep={steps.length === id + 1}
                                            fontSize='3ch'
                                        />
                                    ))}

                                </Stack>
                            </Center>
                        </Container>
                    </Box>
                </Center>
                <Spacer />
                <Button size='lg' fontSize='3ch' bg='red.300' onClick={() => reset()}>Reiniciar</Button>
            </VStack>
            {!(isLoadingDevices || isLoadingTags || isLoadingOrders) ? <VStack flex='2' p={4} spacing={4}>


                <Select
                    fontSize='3ch'
                    fontFamily='"Courier New", Courier, monospace'
                    bg={background}
                    placeholder='Selecciona una operación'
                    mt='5%'
                    value={selectedOperation}
                    onChange={handleOperationChange}>
                    {
                        operations.map((operation, id) => (
                            <option key={id} value={operation.name} style={{ fontFamily: '"Courier New", Courier, monospace' }}>
                                {operation.name}
                            </option>
                        ))
                    }
                </Select>

                <Select
                    fontSize='3ch'
                    fontFamily='"Courier New", Courier, monospace'
                    bg={background}
                    placeholder='Selecciona una orden'
                    mt='2%'
                    value={selectedOrder}
                    onChange={handleOrderChange}
                    disabled={allOrders.length === 0 || currentStep < 1}>
                    {allOrders.map((order, id) => (
                        selectedOperationDescription ? (
                            <option key={id} value={order.OrderID} style={{ fontFamily: '"Courier New", Courier, monospace' }}>
                                {order.description ? `${order.OrderID} - ${order.description}` : order.OrderID}
                            </option>
                        ) : (
                            <option key={id} value={order.OrderID} style={{ fontFamily: '"Courier New", Courier, monospace' }}>
                                {order.OrderID}
                            </option>
                        )
                    ))}
                </Select>

                <Select
                    fontSize='3ch'
                    fontFamily='"Courier New", Courier, monospace'
                    bg={background}
                    placeholder='Seleccione una ubicación'
                    mt='2%'
                    value={Object.keys(selectedLogicalDevice).length > 0 ? JSON.stringify(selectedLogicalDevice) : ''}
                    onChange={handleLogicalDeviceChange}
                    disabled={currentStep < 2}>
                    {
                        logicalDevices.devices.length > 0 ?
                            logicalDevices.devices.map((device, id) => (
                                <option key={id} value={JSON.stringify({ name: device, id: logicalDevices.id })} style={{ fontFamily: '"Courier New", Courier, monospace' }}>
                                    {device}
                                </option>
                            ))
                            :
                            <option disabled style={{ fontFamily: '"Courier New", Courier, monospace' }}>No options available</option>
                    }
                </Select>



                {currentStep > 2 && <Box
                    fontSize='5ch'
                    color='white'
                    mt='5%'
                    w='60%'
                    h='300px'
                    bg='green.500'
                    borderRadius='10px'
                    onClick={() => handleGetOrderDetail()}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    cursor="pointer"

                >
                    Continuar
                </Box>}

                <Spacer />


            </VStack> : <VStack flex='2' p={4} spacing={4}> <Center h="100%">
                <Center height="100vh" width="100%">
                    <Spinner size="xl" thickness="6px" speed="0.65s" emptyColor="gray.200" color="blue.500" width="150px" height="150px" />
                </Center>
            </Center></VStack>}
        </Flex>
    );
}

export default Form;